import { useAppSelector } from "@/store/app/hooks";

import {
  carrierReportDataSelector,
  isCarrierReportLockSelector,
} from "@/store/features/carrier-report/carrierReportSelectors";

import { Button, Link } from "@nextui-org/react";
import { sendAmplitudeData } from "@/analytics";
import { AMPLITUDE_EVENTS } from "@/analytics/events";
import { userDataSelector } from "@/store/features/account/accountSelectors";

const statusColorsMap: Record<string, string> = {
  "not approved": "#F04438",
  approved: "#17B26A",
  "no data": "lightgray",
};

export const OTRFactoringAdBlock = () => {
  const user = useAppSelector(userDataSelector);
  const isCarrierReportLock = useAppSelector(isCarrierReportLockSelector);
  const carrierReportData = useAppSelector(carrierReportDataSelector);

  const { leadToken } = user || {};

  const { otrFactoringInfo } = carrierReportData || {};

  const approvedText = otrFactoringInfo?.brokerTestResult || "No Data";

  const handleFactoringClick = () => {
    sendAmplitudeData(AMPLITUDE_EVENTS.popupFactoringOTRButtonClicked);
  };

  return (
    <div className="flex gap-2">
      <div
        className="w-fit h-9 flex gap-2 items-center p-1 px-4 rounded-lg flex-shrink-0"
        style={{ background: statusColorsMap[approvedText.toLowerCase()] }}
      >
        <p className="flex flex-col text-sm text-white capitalize">
          {approvedText} by OTR
        </p>
      </div>
      {!isCarrierReportLock && (
        <Button
          as={Link}
          href={`https://otrsolutions.com/partnerships/factor-with-otr-solutions-loadconnect/?leadId=${leadToken}`}
          target="_blank"
          className="flex-shrink-0 h-9 gap-1 bg-otr text-white"
          radius="sm"
          onPress={handleFactoringClick}
        >
          Factor with OTR {" ->"}
        </Button>
      )}
    </div>
  );
};
